var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.875,
    width: 40,
    height: 40,
    rx: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5278 28.402H24.4798V23.6284C24.4798 22.4902 24.4595 21.0248 22.8945 21.0248C21.307 21.0248 21.0641 22.265 21.0641 23.5456V28.4017H18.016V18.5854H20.9421V19.9269H20.9831C21.276 19.4261 21.6991 19.0142 22.2075 18.735C22.7159 18.4558 23.2906 18.3197 23.8702 18.3412C26.9595 18.3412 27.5291 20.3733 27.5291 23.0169L27.5278 28.402ZM14.5768 17.2435C14.227 17.2436 13.885 17.1399 13.5941 16.9456C13.3031 16.7513 13.0764 16.4751 12.9425 16.1519C12.8085 15.8287 12.7734 15.473 12.8416 15.1299C12.9098 14.7867 13.0782 14.4715 13.3255 14.2241C13.5729 13.9767 13.888 13.8081 14.2311 13.7398C14.5742 13.6715 14.9299 13.7065 15.2531 13.8403C15.5763 13.9741 15.8526 14.2008 16.047 14.4917C16.2415 14.7825 16.3453 15.1245 16.3453 15.4743C16.3454 15.7066 16.2997 15.9367 16.2108 16.1513C16.1219 16.3659 15.9917 16.5609 15.8275 16.7252C15.6633 16.8895 15.4683 17.0198 15.2537 17.1088C15.0391 17.1977 14.8091 17.2435 14.5768 17.2435ZM16.1008 28.402H13.0496V18.5854H16.1008V28.402ZM29.0474 10.8751H11.518C11.1201 10.8706 10.7367 11.0243 10.4521 11.3023C10.1675 11.5804 10.0049 11.9601 10 12.3579V29.9607C10.0047 30.3587 10.1672 30.7387 10.4518 31.017C10.7364 31.2953 11.1199 31.4493 11.518 31.445H29.0474C29.4463 31.45 29.8308 31.2965 30.1166 31.0182C30.4023 30.7399 30.5659 30.3595 30.5714 29.9607V12.3567C30.5657 11.958 30.402 11.5779 30.1163 11.2999C29.8305 11.0218 29.4461 10.8699 29.0474 10.8751Z",
    fill: "#068BDC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.c86d52e6a037683fb26cd073394fb248.svg";
export { ForwardRef as ReactComponent };